<p-toast position="top-right"></p-toast>
    <div *ngIf="!selectedStore" class="title-header mb-4">Locations</div>
    <mat-tab-group *ngIf="!selectedStore"  class="tab-group" animationDuration="0ms" [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
        <mat-tab label="Stores">
            <div class="header-controls mb-3">
                <mat-form-field class="w-3 custom-search-field" subscriptSizing="dynamic">
                    <mat-icon matPrefix class="text-gray-500">
                        search
                    </mat-icon>
                    <input matInput type="text"
                        [(ngModel)]="filter.searchTerm"
                        (input)="handleFilterChange()"
                        placeholder="Search by ID or Name" />
                </mat-form-field>

                <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [(ngModel)]="selectedOption">
                    <mat-button-toggle value="table" aria-label="Text align left">
                        <mat-icon>view_list</mat-icon>
                    </mat-button-toggle>
                    <mat-button-toggle value="grid" aria-label="Text align right">
                        <mat-icon>grid_on</mat-icon>
                    </mat-button-toggle>     
                </mat-button-toggle-group>

                <span class="separator-line"></span>

                <button mat-button class="filter-button" (click)="showFilter()">
                    <mat-icon>filter_alt</mat-icon>
                    <span class="button-filter-label">Filter</span>
                </button>

                <button mat-button class="create-store-button" (click)="openCreateStoreSideBar()">
                    <mat-icon>add</mat-icon>
                    <span class="button-createstore-label">Create Store</span>
                </button>
            </div>
            <!-- Table -->
            <div class="spinner-container" *ngIf="isSpinnerVisible">
                <mat-spinner diameter="50"></mat-spinner>
                <p>Loading stores...</p>
            </div>

            <ng-container>
                <mat-table [ngClass]="{'hidden': selectedOption !== 'table'}" [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">
                    <ng-container *ngFor="let col of cols" [matColumnDef]="col.field">
                        <mat-header-cell *matHeaderCellDef [mat-sort-header]="col.field" [disabled]="col.disableSort" [style.width]="col.width">
                            <div>
                                {{col.header}}
                            </div>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let store" 
                                (click)="onSelectStoreClick(store)" 
                                class="cursor-pointer"
                                [title]="'Click to select store'">
                            <ng-container *ngIf="col.field === 'StatusName'; else defaultCell">
                                <span [class]="'status-badge status-' + store[col.field].toLowerCase().replace(' ', '-')">{{store[col.field]}}</span>
                            </ng-container>
                            <ng-template #defaultCell>
                                {{store[col.field]}}
                            </ng-template>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Published Status">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="PublishedStatus" class="published-status-header">
                            Published Status
                        </mat-header-cell>
                        <mat-cell *matCellDef="let store">
                            <mat-slide-toggle 
                                [checked]="store.PublishedStatus === 'Active'" 
                                color="primary" 
                                class="custom-toggle"
                                (change)="onPublishedStatusToggle($event, store)">
                                <span class="ml-2 toggle-label"  [class.active-label]="store.PublishedStatus === 'Active'">
                                    {{ store.PublishedStatus }}
                                </span>
                            </mat-slide-toggle>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
                <div *ngIf="!isSpinnerVisible && dataSource.data.length === 0" class="no-results-message text-center py-4 text-gray-600">
                    No results found
                </div>
                <mat-paginator [ngClass]="{'hidden': selectedOption !== 'table'}" [length]="totalRecords"
                            [pageSize]="rowsPerPage"
                            [pageSizeOptions]="rowsPerPageOptions"
                            (page)="handlePageChange($event)"
                            showFirstLastButtons>
                </mat-paginator>
            </ng-container>
        </mat-tab>
    <mat-tab label="Groups">
        <partner-mart-locations-groups></partner-mart-locations-groups>
    </mat-tab>
    </mat-tab-group>
    <ng-container *ngIf="selectedOption === 'grid'">
    <create-store-container 
        [stores]="stores"
        [isActive]="true"
    >
        <div class="global-store-header mb-3" header>
            Create your store
        </div>
    </create-store-container>
    </ng-container>
    <p-sidebar [(visible)]="showFilterSidebar"
            [position]="'right'"
            [baseZIndex]="10000"
            (onHide)="changedVisibleFilterSidebar(false)">
        <ng-template pTemplate="header" class="filter-header filter-text-color">Filter</ng-template>
        <div class="flex flex-column mt-2">
            <mat-label class="filter-label filter-text-color mb-2 mt-1">Store City</mat-label>
            <input class="filter-input filter-input-padding" type="text" [(ngModel)]="filter.store" placeholder="Search Store" />
        </div>
        <div class="flex flex-column mt-2">
            <mat-label class="filter-label filter-text-color mb-2 mt-4">Last Transaction</mat-label>
            <div class="flex">
                <p-calendar class="filter-input calendar-input" [showButtonBar]="true"
                            [(ngModel)]="filter.lastTransactionDate"
                            placeholder="Select Date"></p-calendar>
                <img src="../Content/xpress-app/images/svg/icon_calendar.svg" class="icon_calendar" />
            </div>
        </div>
        <div class="flex flex-column mt-2">
            <mat-label class="filter-label filter-text-color mb-2 mt-4">Store Status</mat-label>
            <ng-container *ngFor="let status of storeStatuses; let i = index;">
                <div class="ml-3 flex filter-elem-height">
                    <input id="check{{i}}" type="checkbox" [checked]="filter.storeStatuses.has(status.value)"
                        class="filter-checkbox" (change)="addStoreStatus(!filter.storeStatuses.has(status.value), status.value)">
                    <mat-label class="mt-3 ml-4 filter-value filter-text-color">{{status.name}}</mat-label>
                </div>
            </ng-container>
        </div>

        <div class="flex flex-column mt-2">
            <mat-label class="filter-label filter-text-color mb-2 mt-4">Published Status</mat-label>
            <div class="flex align-items-center filter-elem-height">
                <p-radioButton [value]="null" [(ngModel)]="filter.publishedStatus" inputId="publishedStatusAll"></p-radioButton>
                <mat-label class="filter-value ml-3">All</mat-label>
            </div>
            <div class="flex align-items-center filter-elem-height">
                <p-radioButton [value]="true" [(ngModel)]="filter.publishedStatus" inputId="publishedStatusActive"></p-radioButton>
                <mat-label class="filter-value ml-3">Active</mat-label>
            </div>
            <div class="flex align-items-center filter-elem-height">
                <p-radioButton [value]="false" [(ngModel)]="filter.publishedStatus" inputId="publishedStatusInactive"></p-radioButton>
                <mat-label class="filter-value ml-3">Inactive</mat-label>
            </div>
        </div>
        <ng-template pTemplate="footer" class="flex justify-content-start mt-4">
            <button pButton class="btn-darkblue filter-button" label="Apply" (click)="getStores(0)"></button>
            <button pButton class="btn-secondary filter-button ml-3" label="Clear" (click)="clearFilter()"></button>
        </ng-template>
    </p-sidebar>
<partner-mart-locations-details #detailsComponent *ngIf="selectedStore" [selectedStore]="selectedStore" [stores]="stores" [merchantId]="merchantId" (hideDetails)="hideDetails()"></partner-mart-locations-details>
